import {
  getGetUnreadCountQueryKey,
  getListNotificationsQueryKey,
  type NotificationsNotificationResponse,
} from '@smarthome/api';
import type { QueryClient } from '@tanstack/react-query';

type NotificationsListResponse = {
  notifications?: NotificationsNotificationResponse[];
};

type UnreadCountResponse = {
  count?: number;
};

export function markNotificationReadInCache(
  queryClient: QueryClient,
  notificationID: string,
  readAt: string
) {
  let markedUnread = false;

  queryClient.setQueriesData(
    { queryKey: getListNotificationsQueryKey() },
    (existing: NotificationsListResponse | undefined) => {
      if (!existing?.notifications) {
        return existing;
      }

      return {
        ...existing,
        notifications: existing.notifications.map((notification) => {
          if (notification.id !== notificationID || notification.readAt) {
            return notification;
          }

          markedUnread = true;
          return { ...notification, readAt };
        }),
      };
    }
  );

  if (!markedUnread) {
    return;
  }

  queryClient.setQueryData(
    getGetUnreadCountQueryKey(),
    (existing: UnreadCountResponse | undefined) => {
      if (!existing) {
        return existing;
      }

      return {
        ...existing,
        count: Math.max((existing.count ?? 0) - 1, 0),
      };
    }
  );
}

export function markAllNotificationsReadInCache(queryClient: QueryClient, readAt: string) {
  queryClient.setQueriesData(
    { queryKey: getListNotificationsQueryKey() },
    (existing: NotificationsListResponse | undefined) => {
      if (!existing?.notifications) {
        return existing;
      }

      return {
        ...existing,
        notifications: existing.notifications.map((notification) => ({
          ...notification,
          readAt: notification.readAt ?? readAt,
        })),
      };
    }
  );

  queryClient.setQueryData(
    getGetUnreadCountQueryKey(),
    (existing: UnreadCountResponse | undefined) =>
      existing
        ? {
            ...existing,
            count: 0,
          }
        : existing
  );
}
